module.exports = __webpack_public_path__ + "./img/my_combinations_results.svg";